import axios from 'axios';

const searchImages = async (term) => {
   const response = await axios.get('https://api.unsplash.com/search/photos', {
        headers: {
            Authorization: 'Client-ID Fq2xDqzNeCsZECj9E3ya5uc4sT1P8ExywTCj1gFx_hw'
        },
        params: {
            query: term,
        },
    });

    return response.data.results;
};

export default searchImages;
